// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************

export enum SearchableField {
  SEARCHABLE_FIELD_ACCOUNT_ID = 0,
  SEARCHABLE_FIELD_ACCOUNT_GROUP_NAME = 1,
  SEARCHABLE_FIELD_PRIMARY_DOMAIN = 2,
}

export enum SortDirection {
  SORT_DIRECTION_ASC = 0,
  SORT_DIRECTION_DESC = 1,
}

export enum SortField {
  SORT_FIELD_MODIFIED = 0,
  SORT_FIELD_CREATED = 1,
  SORT_FIELD_ACCOUNT_GROUP_NAME = 2,
  SORT_FIELD_PRIMARY_DOMAIN = 3,
}
